import { render, staticRenderFns } from "./1222_可以攻击国王的皇后.md?vue&type=template&id=542b0af5&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports